const localesByCountryCode = {
  es: [
    'ES',
    'MX',
    'AR',
    'CL',
    'CO',
    'PE',
    'VE',
    'BO',
    'PY',
    'UY',
    'DO',
    'CR',
    'GT',
    'HN',
    'NI',
    'SV',
    'PA',
    'CU',
  ],
  en: [
    'US',
    'GB',
    'CA',
    'AU',
    'NZ',
    'IE',
    'ZA',
    'IN',
    'PH',
    'SG',
    'MY',
    'NG',
    'JM',
    'TT',
  ],
  fr: ['FR', 'CA', 'BE', 'CH', 'LU', 'MC'],
  de: ['DE', 'AT', 'CH', 'LU'],
  zh: ['CN', 'TW', 'HK', 'SG'],
  pt: ['PT', 'BR', 'MZ', 'AO', 'GW', 'CV', 'TL', 'ST'],
  it: ['IT', 'CH', 'SM', 'VA'],
  nl: ['NL', 'BE', 'SR', 'AW', 'CW'],
  ar: ['SA', 'AE', 'EG', 'IQ', 'JO', 'LB', 'OM', 'QA', 'SY', 'YE', 'KW', 'BH'],
  ru: ['RU', 'BY', 'KZ', 'KG'],
  ja: ['JP'],
  ko: ['KR'],
  sv: ['SE', 'FI'],
  no: ['NO'],
  fi: ['FI'],
  da: ['DK'],
  el: ['GR', 'CY'],
  tr: ['TR'],
  he: ['IL'],
  cs: ['CZ'],
  sk: ['SK'],
  pl: ['PL'],
  hu: ['HU'],
  ro: ['RO'],
  bg: ['BG'],
  uk: ['UA'],
  hr: ['HR'],
  sr: ['RS', 'ME', 'BA'],
  lt: ['LT'],
  lv: ['LV'],
  et: ['EE'],
  sl: ['SI'],
  mk: ['MK'],
  th: ['TH'],
  vi: ['VN'],
  ms: ['MY', 'BN'],
  id: ['ID'],
};

export const getLocaleFromCountryCode = (countryCode: string) => {
  const upperCountryCode = countryCode.toUpperCase();

  for (const [languageCode, countries] of Object.entries(
    localesByCountryCode
  )) {
    if (countries.includes(upperCountryCode)) {
      return `${languageCode}-${upperCountryCode}`;
    }
  }

  return null;
};
